import simg from '../images/service/1.png'
import simg2 from '../images/service/2.png'
import simg3 from '../images/service/3.png'

import sImgS1 from '../images/service-single/coolingImg3.png'
import sImgS2 from '../images/service-single/interiorImg4.png'
import sImgS3 from '../images/service-single/machineryImg2.png'

import sSingleimg1 from '../images/service-single/2.jpg'
import sSingleimg2 from '../images/service-single/3.jpg'

// Her servise özel görseller (varsa)
import coolingImg1 from '../images/service-single/coolingImg1.png'
import coolingImg2 from '../images/service-single/coolingImg2.png'
import interiorImg1 from '../images/service-single/interiorImg1.png'
import interiorImg2 from '../images/service-single/interiorImg2.png'
import machineryImg1 from '../images/service-single/machineryImg1.png'
import machineryImg2 from '../images/service-single/machineryImg3.png'

const Services = [
    {
        Id: '1',
        slug: 'sogutma-sistemleri',
        sImg: simg,
        sImgS: sImgS1,
        sTitle: 'Soğutma Sistemleri',
        pageTitle: 'Endüstriyel ve Ticari Soğutma Sistemleri',
        shortDescription: 'Endüstriyel ve ticari soğutma ihtiyaçlarınıza yönelik kapsamlı çözümler sunuyoruz.',
        description: 'Soğuk hava deposu kurulumu, endüstriyel soğutma sistemleri, montaj, bakım ve teknik servis hizmetlerimizle yanınızdayız. 20 yılı aşkın deneyimimizle gıda sektöründen lojistiğe, ilaç depolamadan kimyasal ürün muhafazasına kadar geniş bir yelpazede soğutma çözümleri sunuyoruz.',
        des2: 'Enerji verimli sistem çözümlerimiz ile işletmenizin soğutma maliyetlerini %40\'a varan oranlarda düşürürken çevre dostu uygulamalar gerçekleştiriyoruz. İklimlendirme ve soğutma sistemlerinde son teknoloji ekipmanlar kullanarak maksimum verimlilik sağlıyoruz.',
        des3: 'Uzman ekibimiz, ihtiyacınıza özel soğutma sistemlerini projelendirir, kurar ve düzenli bakım ile kesintisiz çalışmayı garanti eder. 7/24 acil servis hizmetimizle olası arızalarda anında müdahale ediyoruz.',
        icon: 'flaticon-advisor',
        ssImg1: coolingImg1,
        ssImg2: coolingImg2,
        // İletişim bilgileri
        contactPhone: '+90533 301 39 85',
        contactInstagram: 'kuyassogutma'
    },
    {
        Id: '2',
        slug: 'ic-mimarlık-proje-uygulama',
        sImg: simg2,
        sImgS: sImgS2,
        sTitle: 'İç Mimarlık & Proje Uygulama',
        pageTitle: 'Profesyonel İç Mimarlık ve Uygulama Hizmetleri',
        shortDescription: 'Konut ve ticari alanlar için yaratıcı ve fonksiyonel iç mimarlık hizmetleri sunuyoruz.',
        description: 'Konut ve ticari alanlar için yaratıcı ve fonksiyonel iç mimarlık hizmetleri sunuyoruz. 3D tasarım, proje planlama, anahtar teslim uygulama ve dekorasyon çözümleriyle hayalinizdeki mekanları gerçeğe dönüştürüyoruz. Modern çizgilerden klasik tasarımlara kadar her tarza uygun projeler geliştiriyoruz.',
        des2: 'Mobilya tasarımı ve temininden uygulama aşamasına kadar tüm süreçleri yönetiyor, size özel çözümler üretiyoruz. Yerli ve yabancı markalarla işbirliğimiz sayesinde her bütçeye uygun alternatifler sunabiliyoruz.',
        des3: 'Projelerinizi estetik, konfor ve işlevsellik ön planda tutarak, bütçenize uygun şekilde hayata geçiriyoruz. Müşteri memnuniyetini her şeyin önünde tutarak, teslim tarihlerine sadık kalıyoruz.',
        icon: 'flaticon-team',
        ssImg1: interiorImg1,
        ssImg2: interiorImg2,
        contactPhone: '+90 532 359 26 23',
        contactInstagram: 'kuyasdesign'
    },
    {
        Id: '3',
        slug: 'is-makineleri',
        sImg: simg3,
        sImgS: sImgS3,
        sTitle: 'İş Makineleri',
        pageTitle: 'İş Makineleri Satış, Kiralama ve Servis Hizmetleri',
        shortDescription: 'İnşaat, altyapı ve endüstriyel projeleriniz için iş makineleri temini, satışı ve kiralama hizmetleri.',
        description: 'İnşaat, altyapı ve endüstriyel projeleriniz için iş makineleri temini, satışı ve kiralama hizmetleri sunuyoruz. Geniş makine parkımız ve uzman kadromuzla ihtiyacınıza en uygun çözümleri sağlıyoruz. Yerli ve yabancı markaların satış ve kiralama hizmetlerini sunuyoruz.',
        des2: 'Yedek parça temini, bakım ve onarım hizmetlerimizle makinelerinizin her zaman çalışır durumda kalmasını sağlıyoruz. Orijinal yedek parça kullanımı ve uzman ekibimizle makine ömrünü uzatıyoruz.',
        des3: 'Teknik servis ekibimiz, arıza durumunda hızlı müdahale ve düzenli bakım ile iş sürekliliğinizi destekliyor. Operatör eğitimleri ve danışmanlık hizmetleriyle de yanınızdayız.',
        icon: 'flaticon-taxes',
        ssImg1: machineryImg1,
        ssImg2: machineryImg2,
        contactPhone: '+90533 301 39 85',
        contactInstagram: 'kyslojistik'
    },
    {
        Id: '4',
        slug: 'sogutma-sistemleri',
        sImg: simg,
        sImgS: sImgS1,
        sTitle: 'Teknik Servis',
        pageTitle: 'Endüstriyel ve Ticari Soğutma Sistemleri',
        shortDescription: 'Endüstriyel ve ticari soğutma ihtiyaçlarınıza yönelik kapsamlı çözümler sunuyoruz.',
        description: 'Soğuk hava deposu kurulumu, endüstriyel soğutma sistemleri, montaj, bakım ve teknik servis hizmetlerimizle yanınızdayız. 20 yılı aşkın deneyimimizle gıda sektöründen lojistiğe, ilaç depolamadan kimyasal ürün muhafazasına kadar geniş bir yelpazede soğutma çözümleri sunuyoruz.',
        des2: 'Enerji verimli sistem çözümlerimiz ile işletmenizin soğutma maliyetlerini %40\'a varan oranlarda düşürürken çevre dostu uygulamalar gerçekleştiriyoruz. İklimlendirme ve soğutma sistemlerinde son teknoloji ekipmanlar kullanarak maksimum verimlilik sağlıyoruz.',
        des3: 'Uzman ekibimiz, ihtiyacınıza özel soğutma sistemlerini projelendirir, kurar ve düzenli bakım ile kesintisiz çalışmayı garanti eder. 7/24 acil servis hizmetimizle olası arızalarda anında müdahale ediyoruz.',
        icon: 'flaticon-advisor',
        ssImg1: coolingImg1,
        ssImg2: coolingImg2,
        // İletişim bilgileri
        contactPhone: '+90 531 218 34 36',
        contactInstagram: 'kuyassogutma'
    },
];

export default Services;